<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    title?: string
    description?: string
  }>(),
  {
    title: '',
    description: '',
  },
)
</script>

<template>
  <div>
    <div
      class="flex flex-col flex-wrap justify-between gap-2 py-2 sm:flex-row md:items-center"
    >
      <div class="flex flex-row gap-2 items-center">
        <slot name="start" />
        <div class="flex items-center gap-5">
          <div>
            <slot name="title">
              <p
                v-if="props.title"
                class="text-md font-semibold"
                v-html="props.title"
              />
            </slot>
            <slot name="description">
              <p
                v-if="props.description"
                class="text-muted-foreground text-sm"
                v-html="props.description"
              />
            </slot>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap items-center gap-3">
        <slot />
      </div>
    </div>
  </div>
</template>
